import { createContext, ReactNode, useContext, useMemo } from 'react';

import { useAuth } from '../AuthContext';

import { defineAbilitiesFor, TAppAbility } from './defineAbility';

interface AbilityContextProps {
  ability: TAppAbility;
}

const AbilityContext = createContext<AbilityContextProps | undefined>(
  undefined,
);

export function AbilityProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const { userData: user } = useAuth();
  const ability = useMemo(() => defineAbilitiesFor(user), [user]);
  const contextValue = useMemo(() => ({ ability }), [ability]);

  return (
    <AbilityContext.Provider value={contextValue}>
      {children}
    </AbilityContext.Provider>
  );
}

export const useAbility = (): TAppAbility => {
  const context = useContext(AbilityContext);
  if (!context) {
    throw new Error('useAbility must be used within an AbilityProvider');
  }
  return context.ability;
};
